module.exports = __webpack_public_path__ + "img/cloud-hosting-animate.557ad7ef.svg";